import React, { useState, useEffect } from "react";
import Moment from "react-moment";
import { useSelector } from "react-redux";

import { SubTab } from "../Cms/TabNInput";
import useRequest from "../../hooks/useRequest";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import { API } from "../../constant/api";
import moment from "moment";

const Activated = () => (
  <span className="label label-lg label-light-success label-inline">
    Activated
  </span>
);

const Deactivated = () => (
  <span className="label label-lg label-light-danger label-inline">
    Deactivated
  </span>
);

const ViewOne = (props) => {
  const { id } = props.match.params;
  const [activeTab, setActiveTab] = useState("en");
  const [templateData, setTemplateData] = useState([]);

  const { response, request } = useRequest();

  const { date_format, languages } = useSelector((state) => state.setting);

  useEffect(() => {
    request("GET", `notification-template/single/${id}`);

    document.title = "View Notification Template - Easyspare";
  }, []);

  useEffect(() => {
    if (response) {
      const { name, action, category, translations } = response.data;
      setTemplateData([
        { title: "Template Name", value: name },
        { title: "Action", value: action },
        { title: "Category", value: category },
        { title: "Translations", value: translations },
      ]);
    }
  }, [response]);
  const handleTabChange = (lang) => {
    setActiveTab(lang); // Update active tab index when tab is changed
  };
  return (
    <div
      className="content  d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <Breadcrumb
        title="View Notification Template"
        links={[
          { to: "/", name: "Dashboard" },
          {
            to: "/notification-template",
            name: "Back To Notification Template",
          },
        ]}
      />

      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <div className="card card-custom gutter-b">
            <div className="card-header card-header-tabs-line">
              <div className="card-toolbar">
                <ul
                  className="nav nav-tabs nav-tabs-space-lg nav-tabs-line nav-bold nav-tabs-line-3x"
                  role="tablist"
                >
                  {["Notification Information"].map((data, index) => (
                    <SubTab key={index} name={data} index={index} />
                  ))}
                </ul>
              </div>
            </div>

            <div className="card-body px-0">
              <div className="tab-content px-10">
                <div
                  className={`tab-pane active`}
                  id={`kt_apps_contacts_view_tab_3`}
                  role="tabpanel"
                >
                  {templateData.length > 0 &&
                    templateData.map((temp, index) =>
                      typeof temp?.value == "object" ? (
                        <React.Fragment key={index}>
                          <div className="card-header card-header-tabs-line">
                            <div className="card-toolbar">
                              <ul
                                className="nav nav-tabs nav-tabs-space-lg nav-tabs-line nav-bold nav-tabs-line-3x"
                                role="tablist"
                              >
                                {temp?.value &&
                                  Object.keys(temp?.value)?.map((res, i) => (
                                    <SubTab
                                      key={res}
                                      name={
                                        languages?.find((item) =>
                                          item.code?.includes(res)
                                        )?.name || "N/A"
                                      }
                                      index={i}
                                      image=""
                                      tabName={`language_${i}`}
                                      onClick={() => handleTabChange(res)}
                                    />
                                  ))}
                              </ul>
                            </div>
                          </div>
                          <div className="card-body px-0">
                            <div className="form-group row my-2">
                              <label className="col-4 col-form-label">
                                Subject
                              </label>
                              <div className="col-8">
                                <span className="form-control-plaintext font-weight-bolder">
                                  {temp?.value[activeTab]?.subject}
                                </span>
                              </div>
                            </div>
                            <div className="form-group row my-2">
                              <label className="col-4 col-form-label">
                                Body
                              </label>
                              <div className="col-8">
                                <span className="form-control-plaintext font-weight-bolder">
                                  {temp?.value[activeTab]?.body}
                                </span>
                              </div>
                            </div>
                          </div>
                        </React.Fragment>
                      ) : (
                        <div key={index} className="form-group row my-2">
                          <label className="col-4 col-form-label">
                            {temp.title}
                          </label>
                          <div className="col-8">
                            <span className="form-control-plaintext font-weight-bolder">
                              {temp.value}
                            </span>
                          </div>
                        </div>
                      )
                    )}

                  <div className="row"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewOne;
